var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 440,
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H440V361L363 440H0V0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2619_19836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.961 412.737V415.513L415.677 439.726L412.883 439.746L439.961 412.737Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.441 439.707L417.637 439.717L439.961 417.458V420.235L420.441 439.707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.99 399.052L437.627 403.675L401.392 439.804L360 440L392.931 407.165H401.667L417.196 391.681V382.737L440 360V373.695L432.99 380.684V399.052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.961 422.19V424.155L424.392 439.687L422.402 439.697L439.961 422.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.608 404.643L439.961 406.002V406.07L406.157 439.775L403.363 439.795L438.608 404.643Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.961 408.016V410.792L410.922 439.756L408.118 439.765L439.961 408.016Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2619_19836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "matrix(-1 0 0 1 440 360)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayRightBg);
export default __webpack_public_path__ + "static/media/display_right_bg.bed418d014d7f9aa69bed15fd4ff02b9.svg";
export { ForwardRef as ReactComponent };